"use strict";
/**
  * Release Version - 0.5.x
  *
  * __globals : 0.5.13 - 16 JUL 2019
  *
  *-------------------------------------------------------- */

// a container to hold underscore template data
_.templateSettings.variable = "__tData";

var __globals = {

     /**
     * Laravel get template route name
     *
     *-------------------------------------------------------- */

     templateRouteName: 'template.get',

      /**
      * Get laravel template url 
      * @param string {viewName} - laravel view file name
      *
      * return url string
      *-------------------------------------------------------- */

      getTemplateURL : function( viewName ) {
        

        var templateURL = window.appConfig['appBaseURL'] 
                        + window.__appImmutables.routes[ this.templateRouteName ];

        // Replace viewName parameter to actual view file name and return new url
        return templateURL.replace('{viewName}', viewName);

      },

      /**
      * Process Redirect state via route
      * @param obj {state} - state
      *
      * return void
      *-------------------------------------------------------- */

      processStateViaRoute : function( state, elseCallback) {
        var stateInfo = window.localStorage.getItem('state_via_route');
        var redirectState = JSON.parse(stateInfo ? stateInfo : '{}');
            window.localStorage.setItem('state_via_route', '');
        if(_.has(redirectState, 'stateName')
            && !_.isUndefined(redirectState.stateName)
            && !_.isEmpty(redirectState.stateName)) {

            _.defer(function(){
                if (_.isEmpty(redirectState.stateParams)) {
                    state.go(redirectState.stateName);
                } else {
                    state.go(redirectState.stateName, redirectState.stateParams);
                }
            });

        } else {
            if(_.isString(elseCallback)) {
                state.go(elseCallback);
            } else {
                elseCallback.call(this, state,redirectState);
            }         
        }
      },

      /**
      * Get qualified State Configuration Object 
      * @param string {url} - URL for state
      * @param string {templateRouteID} - laravel template route ID for this.getTemplateURL
      * @param string {addtionalOptions} - additional object parameters 
      *
      * return Object
      *-------------------------------------------------------- */
      
      stateConfig : function( url, templateRouteID, addtionalOptions ) {

        // check if url not sent
        if ( !url  ) {
          console.error( "Error: URL is missing" );
          throw new Error( "URL is missing" );
        }

        // if templateURL not sent check for template markup
        if ( !templateRouteID && addtionalOptions  
                              && !_.has( addtionalOptions, 'template' ) ) {
        //  console.error( "Error: templateRouteID is missing" );
        //  throw new Error( "templateRouteID is missing" );

          addtionalOptions.template = "";
        }

        var stateOptions =  {
              url : url
            };

        if(templateRouteID) {
            stateOptions.templateUrl 
                = this.getTemplateURL( templateRouteID.replace(/\//g, ".") );
        }

        // assign additional options if available
        if ( addtionalOptions && _.isObject(addtionalOptions) )
        {
          _.assign( stateOptions , addtionalOptions );
        }

        return stateOptions;

      },

    /**
     * Store application messages.
     *
     *-------------------------------------------------------- */
     
     messages : (window.__appImmutables && window.__appImmutables.messages) ? window.__appImmutables.messages : [],

     getReactionMessage : function( reactionCode ) {

        var reactionMessage = this.messages.validation.reactions[reactionCode];

        if( reactionMessage && _.isArray( reactionMessage )) {
          reactionMessage = _.sample(reactionMessage);
        }

        return reactionMessage ? reactionMessage : false;
     },
     __clogCount : 0,
    /**
     * Console the items requested from __clog Laraware helper function
     *
     *-------------------------------------------------------- */
     clog: function(clogData ) {

            var clCount = 1,
                clogType = clogData.__clogType ? clogData.__clogType : '';
            _.forEach(clogData.__clog, function(__clogValue) {
                    _.forEach(__clogValue, function(value) {
                        console.log('%c __clog '+ clogType + ' '+ clCount +" --------------------------------------------------" , 'color: #bada55');
                        console.log('%c '+value, 'color: #9c9c9c');
                        clCount++;
                        __globals.__clogCount++;
                    });
                });

            console.log("%c ------------------------------------------------------------ __clog "+ clogType + " items end." +' TotalCount: '+ __globals.__clogCount, 'color: #bada55');
     },

     /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     * 
     */
    detectIE : function() {
          
          var ua = window.navigator.userAgent;

          // Test values; Uncomment to check result …

          // IE 10
          // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
          
          // IE 11
          // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
          
          // Edge 12 (Spartan)
          // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
          
          // Edge 13
          // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

          var msie = ua.indexOf('MSIE ');
          if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
          }

          var trident = ua.indexOf('Trident/');
          if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
          }

          var edge = ua.indexOf('Edge/');
          if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
          }

          // other browser
          return false;
    },

    /**
     * Access the appImutable items
     *
     * @param string {itemName} - itemName string
     * @param string {itemValue} - update itemValue string     
     *     
     * @return url-friendly mixed
     *-------------------------------------------------------- */

    appImmutable :  function( itemName, itemValue ) {

        if(!itemName) {
            return window.__appImmutables;
        } else if(!itemValue) {
            return window.__appImmutables[itemName];
        } else {
            return window.__appImmutables[itemName] = itemValue;
        }
    },

    /**
     * Access the appTemps items
     *
     * @param string {itemName} - itemName string
     * @param string {itemValue} - update itemValue string     
     *     
     * @return url-friendly mixed
     *-------------------------------------------------------- */

    appTemps :  function( itemName, itemValue ) {

        if(! window.__appTemps) {
            return false
        } else if(!itemName) {
            return window.__appTemps;
        } else if(!itemValue) {
            return window.__appTemps[itemName];
        } else {
            return window.__appTemps[itemName] = itemValue;
        }
    }    

};
/*----------------------DIRECT GLOBALS ---------------------------------------------------------------------------------- */
/**
* Dump and die  
* @param n number of parameters
*
* return void
*-------------------------------------------------------- */
window.__dd = function(arg1, arg2) {

    if( window.appConfig && window.appConfig.debug ) {

        console.error( "JS __dd --------------------------------------------------" );

        var args = Array.prototype.slice.call(arguments);

        for (var i = 0; i < args.length; ++i) {
            console.log(args[i]);
        }

        throw new Error( "-------------------------------------------------- JS __dd END" );
     }
}

/**
* Print data
* @param n number of parameters
*
* return void
*-------------------------------------------------------- */
window.__pr = function() {

    if( window.appConfig && window.appConfig.debug ) {

        console.info( "JS __pr --------------------------------------------------" );

        var args = Array.prototype.slice.call(arguments);

        for (var i = 0; i < args.length; ++i) {
            console.log(args[i]);
        }  

        console.groupCollapsed("-------------------------------------------------- JS __pr END");
        console.trace();
        console.groupEnd();  
        //console.info( "-------------------------------------------------- JS __pr END" );
     }
}